import {HTTP_INTERCEPTORS, HttpBackend, HttpClientModule,} from "@angular/common/http";
import {CommonModule} from "@angular/common";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {APP_INITIALIZER, NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {ToastrModule} from "ngx-toastr";
import {provideUserIdleConfig} from 'angular-user-idle';
import {OktaAuthModule} from "@okta/okta-angular";
import {ModalComponentModule} from "@crs/ivy";

import {AppComponent} from "src/app/app.component";
import {HttpXsrfInterceptor} from "src/app/services/HttpXsrfInterceptor";
import {RoutingModule} from "src/app/routing.module";
import {LoginComponent} from "src/app/login/login.component";
import {LogoutComponent} from "src/app/logout/logout.component";
import {OktaAuthGuard} from "src/app/common/oktaauth.guard";

import {AppConfigService} from "./services/app-config.service";
import {LoadingService} from "./services/loading/loading.service";
import {HttpErrorHandler} from "./services/http-error-handler.service";
import {SessionTimeoutDialogComponent} from './common/session-timeout-dialog/session-timeout-dialog.component';
import { NgxTranslateModule } from './translate/translate.module';
import {LoadingComponent} from "./common/loading/loading.component";
import {FooterModule} from "./common/footer/footer.module";
import {HeaderModule} from "./common/header/header.module";

const appConfigInitializer = (appConfig: AppConfigService) => () => appConfig.loadAuthConfig();

const appHealthCheckInitializerFn = (appConfig: AppConfigService) => () => appConfig.loadAppHealthCheckConfig();

const appDmpCheckInitializerFn = (appConfig: AppConfigService) => () => appConfig.loadAppDmpCheckConfig();


@NgModule({
	declarations: [AppComponent, LoginComponent, LogoutComponent, SessionTimeoutDialogComponent, LoadingComponent],
	imports: [
		CommonModule,
		BrowserAnimationsModule,
		BrowserModule,
		HttpClientModule,
		RoutingModule,
		ToastrModule.forRoot(),
		OktaAuthModule,
		ModalComponentModule,
		NgxTranslateModule,
		FooterModule,
		HeaderModule
	],
	providers: [
		LoadingService,
		AppConfigService,
		provideUserIdleConfig({idle: 600, timeout: 300, ping: 120}),
		{
			provide: APP_INITIALIZER,
			useFactory: appConfigInitializer,
			multi: true,
			deps: [AppConfigService]
		},
		{
			provide: APP_INITIALIZER,
			useFactory: appHealthCheckInitializerFn,
			multi: true,
			deps: [AppConfigService],
		},
		{
			provide: APP_INITIALIZER,
			useFactory: appDmpCheckInitializerFn,
			multi: true,
			deps: [AppConfigService],
		},
		OktaAuthGuard,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpXsrfInterceptor,
			multi: true,
		},
		HttpErrorHandler
	],
	bootstrap: [AppComponent],
})
export class AppModule {
}
